import React, { useContext } from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { GlobalState } from '../../../GlobalState';
import moment from 'moment'
import { Link } from 'react-router-dom';


const SugerenciaHub = () => {

    const state = useContext(GlobalState)
    const [products, setProducts] = state.productsAPI.products

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    console.log(products)

    return (
        <div className='content_sugererHub hub'>
            <Link to={'/publicaciones-contenidos'}>
                <h1 className='content_hub_derach_h1 hub'><i class="fa-solid fa-hand-point-right"></i> Creadoras de Contenido Hub <i class="fa-solid fa-hand-point-left"></i></h1>
            </Link>

            <Slider {...settings}>
                {products.map((product, index) => (
                    <div key={index} className='content_creadoras_content'>
                        <div className="cart_contethub_public_creadoras hub">
                            <div className="header_cart_contenthub_creadoras hub">
                                <img src={product.arrayimagesfakes[0].url} alt="User Avatar" />
                                <div>
                                    <h1>
                                        <Link to={"/publicaciones-contenidos"}>
                                            {product.nombre}
                                        </Link>
                                    </h1>
                                    <small>{moment(product.createdAt).fromNow()}</small>
                                </div>
                            </div>
                            <div className="content_img_contenhub_creadoras">
                                <img src={product.images.url} alt="Content Image" />
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
}

export default SugerenciaHub;